import {
  Component,
  Input,
  OnInit,
  TemplateRef,
  ViewContainerRef,
} from '@angular/core';
import {
  getFormattedDateTime,
  getFormattedTime,
} from '../../../../../global.variable';
import { AppService } from '../../../../app.service';
import { AddEditSiteComponent } from '../../../../shared/components/add-edit-site/add-edit-site.component';
import { ModalDialogueService } from '../../../../shared/components/modal-dialogue/modal-dialogue.service';
import { LoadingSpinnerService } from '../../../../shared/services/loading-spinner.service';
import { ClientsService } from '../../clients/clients.service';

import { firstValueFrom } from 'rxjs';
import { AddCheckpointRouteComponent } from '../../../../shared/components/add-checkpoint-route/add-checkpoint-route.component';
import { UserPromptService } from '../../user-prompts/user-prompt.service';

@Component({
  selector: 'gtapp-add-checklist',
  standalone: false,
  templateUrl: './add-checklist.component.html',
  styleUrl: './add-checklist.component.scss',
})
export class AddChecklistComponent implements OnInit {
  @Input() checkListData: any = [];
  @Input() schedulerForm: any = {};
  @Input() scheduleDatesDict: any = {};
  @Input() dynamicHeight: number = 0;

  openIndex: number = 0;

  siteList: any = [];
  initalsiteListData: any = [];
  selectedSiteData: any = {};

  checkListDataIndexList: any = [];

  userPromptsSearchResults: any = [];
  userPromptsSearchResultsCopy: any = [];
  userPromptTotalCount: number = 0;

  siteExtraDetails: any = {};

  constructor(
    private appService: AppService,
    private clientService: ClientsService,
    private dialogService: ModalDialogueService,
    private spinnerService: LoadingSpinnerService,
    private viewContainerRef: ViewContainerRef,
    private userPromptService: UserPromptService,
  ) {}

  ngOnInit(): void {
    this.onSiteSearch();
    this.getUserPrompts({}, true);
    this.checkListDataIndexList = Array.from(
      { length: this.checkListData?.length || 0 },
      (_, i) => i + 1,
    );
  }
  actionOnLastTextArea(action: 'focus' | 'scroll', timeout = 0) {
    setTimeout(() => {
      const allTextareas = document.querySelectorAll('textarea');

      const lastTextarea = allTextareas[
        allTextareas.length - 1
      ] as HTMLTextAreaElement;

      if (action == 'focus') {
        lastTextarea?.focus();
      } else {
        lastTextarea?.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
          inline: 'end',
        });
      }
    }, timeout);
  }

  onInputTaskNote(event: any, currentTask: any, taskList: any) {
    const textarea: any = event.target as HTMLTextAreaElement;
    textarea?.scrollIntoView({
      behavior: 'smooth',
      block: 'center',
      inline: 'end',
    });
    const maxHeight = 150;

    if (currentTask) {
      currentTask.ngStyle = {
        height: Math.max(62, Math.min(textarea.scrollHeight, maxHeight)) + 'px',
        overflowY: textarea.scrollHeight > maxHeight ? 'auto' : 'hidden',
      };
    }
    if (taskList) this.normalizeTaskList(taskList);
  }
  normalizeTaskList(taskList: any) {
    const nonEmptyTasks = taskList.filter((task: any) => task?.note?.trim());

    const removedItem = taskList?.length - nonEmptyTasks?.length == 2;

    taskList.length = 0;
    taskList.push(...nonEmptyTasks);

    taskList.push({ note: '' });

    if (removedItem) {
      this.actionOnLastTextArea('focus');
    }
  }
  filterEmptyTasks() {
    this.checkListData?.forEach((checkList: any) => {
      checkList.tasks = checkList?.tasks?.filter((task: any) =>
        task?.note?.trim(),
      );
    });
    this.openIndex = this.checkListData?.length;
    this.checkListData.push({ tasks: [{}] });

    this.checkListDataIndexList = Array.from(
      { length: this.checkListData?.length || 0 },
      (_, i) => i + 1,
    );
    this.actionOnLastTextArea('scroll');

    this.shiftFocus('siteId' + this.openIndex, 350);
  }
  editSiteField(checkList: any, elementId: string) {
    checkList.site = {};
    checkList.selectedCheckpoints = [];
    this.shiftFocus(elementId);
    this.updateInitialDataList();
  }
  updateInitialDataList() {
    setTimeout(() => {
      this.siteList = JSON.parse(JSON.stringify(this.initalsiteListData));
    }, 200);
  }
  shiftFocus(elementId: string, timeOut = 200) {
    setTimeout(() => {
      var element = <HTMLInputElement>document.getElementById(elementId);

      element?.focus();
    }, timeOut);
  }
  onSiteSearch(event?: any) {
    const searchString = event ? event.target.value : '';

    this.selectedSiteData.tempValue = searchString;

    this.clientService
      .searchSites({
        search_str: searchString,
      })
      .subscribe((res: any) => {
        if (res['status'] == 'success') {
          this.siteList = res?.data?.splice(0, 10);
          if (!searchString) {
            this.initalsiteListData = JSON.parse(JSON.stringify(this.siteList));
          }
        }
      });
  }
  async onSelectSite(data: any, checkList: any, index: number) {
    if (data?.key === 0) {
      this.openAddSiteForm(checkList, index);
    }

    if (data?.id) {
      checkList.site = data;
      checkList.selectedCheckpoints = [];
      checkList.enable_reporting = true;
      this.appService.removeToolTips();

      this.appService.initializeBootstrapTooltips();

      this.getSiteDetailById(checkList);

      this.actionOnLastTextArea('scroll', 50);
      this.actionOnLastTextArea('focus', 100);

      this.updateInitialDataList();
    }
  }
  getSiteDetailById(checkList: any) {
    const siteId = checkList?.site?.id;
    if (this.siteExtraDetails?.[siteId]) {
      checkList.site = {
        ...checkList?.site,
        ...this.siteExtraDetails?.[siteId],
      };
    } else {
      this.clientService
        .getSiteDetailsById(checkList?.site?.id, {
          get_details: 1,
          site_fields: JSON.stringify(['information', 'cp_count']),
        })
        .subscribe((response: any) => {
          if (response['status'] == 'success') {
            checkList.site = { ...checkList?.site, ...response?.data };
            this.siteExtraDetails[siteId] = response?.data;
          }
        });
    }
  }
  openAddSiteForm(checkList: any, index: number) {
    const dialogRef = this.dialogService.open(AddEditSiteComponent, {
      data: {
        detailData: { company_name: this.selectedSiteData?.tempValue },
      },
    });
    dialogRef.afterClosed().subscribe((value: any) => {
      if (value !== 'close') {
        this.onSelectSite(value, checkList, index);
      }
    });
  }
  setTime(day: any, time: any) {
    const date = new Date(day);
    const [hours, minutes] = time?.split(':');
    date.setHours(hours, minutes, 0, 0);
    return date;
  }
  formatTaskSchedule(task: any) {
    const isSchedulerInfoPresent = this.schedulerForm?.value?.id;
    let taskSchedule: any = {
      invalid: {},
      showItems: {},
    };

    // If schedulerInfo exists, use it for the task schedule
    if (isSchedulerInfoPresent) {
      taskSchedule.reminder = task?.schedule?.reminder;

      // Start and End DateTime logic (from task or schedulerInfo)
      taskSchedule.start_datetime = getFormattedDateTime(
        task?.schedule?.start_datetime ||
          this.schedulerForm?.value?.start_datetime,
      );
      taskSchedule.end_datetime = getFormattedDateTime(
        task?.schedule?.end_datetime || this.schedulerForm?.value?.end_datetime,
      );

      taskSchedule.start_time = getFormattedTime(taskSchedule.start_datetime);
      taskSchedule.end_time = getFormattedTime(taskSchedule.end_datetime);

      // Min and Max DateTime logic (current time vs scheduler info start time)
      taskSchedule.minDateTime = getFormattedDateTime(
        Math.max(
          new Date().getTime(),
          new Date(this.schedulerForm?.value?.start_datetime).getTime(),
        ),
      );
      taskSchedule.maxDateTime = getFormattedDateTime(
        this.schedulerForm?.value?.end_datetime,
      );

      // Logic to determine whether to show start/end DateTime and Time
      taskSchedule.showItems.startEndDateTime =
        this.isSameDayCheck(taskSchedule.minDateTime) !==
        this.isSameDayCheck(taskSchedule.maxDateTime);

      taskSchedule.showItems.startEndTime =
        this.isSameDayCheck(taskSchedule.minDateTime) ===
        this.isSameDayCheck(taskSchedule.maxDateTime);
    } else {
      // Scheduler info doesn't exist, so use task.schedule and other default values
      taskSchedule.reminder = true;
      taskSchedule.start_time = this.schedulerForm?.value?.start_time;
      taskSchedule.end_time = this.schedulerForm?.value?.end_time;

      // Start and End DateTime logic (from task schedule or fallback to schedulerInfo)
      taskSchedule.start_datetime = getFormattedDateTime(
        this.schedulerForm?.value?.start_day +
          ' ' +
          this.schedulerForm?.value?.start_time,
      );
      taskSchedule.end_datetime = getFormattedDateTime(
        this.schedulerForm?.value?.end_day +
          ' ' +
          this.schedulerForm?.value?.end_time,
      );

      taskSchedule.minDateTime = taskSchedule.start_datetime;
      taskSchedule.maxDateTime = taskSchedule.end_datetime;

      // Handle available days filter if needed
      taskSchedule.availableDays = this.filterOutWeekDays();

      // Show DateTime and Time based on conditions
      taskSchedule.showItems.startEndDateTime =
        this.isSameDayCheck(taskSchedule.start_datetime) !==
          this.isSameDayCheck(taskSchedule.end_datetime) &&
        this.schedulerForm?.value?.repeat_type === 'once';

      taskSchedule.showItems.startEndTime =
        this.isSameDayCheck(taskSchedule.start_datetime) ===
          this.isSameDayCheck(taskSchedule.end_datetime) &&
        this.schedulerForm?.value?.repeat_type === 'once' &&
        !taskSchedule.availableDays?.length;

      // If task has its own schedule, override the above values with it
      if (task?.schedule?.start_datetime && task?.schedule?.end_datetime) {
        taskSchedule.start_datetime = getFormattedDateTime(
          task.schedule.start_datetime,
        );
        taskSchedule.end_datetime = getFormattedDateTime(
          task.schedule.end_datetime,
        );
        taskSchedule.start_time = getFormattedTime(
          task.schedule.start_datetime,
        );
        taskSchedule.end_time = getFormattedTime(task.schedule.end_datetime);
        taskSchedule.minDateTime = taskSchedule.start_datetime;
        taskSchedule.maxDateTime = taskSchedule.end_datetime;
        taskSchedule.availableDays = [];

        // Update visibility of start/end DateTime and Time based on task's schedule
        taskSchedule.showItems.startEndDateTime =
          this.isSameDayCheck(taskSchedule.start_datetime) !==
          this.isSameDayCheck(taskSchedule.end_datetime);

        taskSchedule.showItems.startEndTime =
          this.isSameDayCheck(taskSchedule.start_datetime) ===
            this.isSameDayCheck(taskSchedule.end_datetime) &&
          !taskSchedule.availableDays?.length;
      } else if (task?.schedule?.start_time && task?.schedule?.end_time) {
        taskSchedule = { ...taskSchedule, ...task?.schedule };
      }
    }

    return taskSchedule;
  }
  addPromptTask(promptData: any, checkList: any) {
    checkList.tasks = [
      ...checkList?.tasks?.filter((task: any) => !!task?.note),
      { note: promptData?.name, user_prompt_id: promptData?.id },
      {},
    ];
    setTimeout(() => {
      const inputField: any = document.getElementById('promptSelectId');
      if (inputField) inputField.value = '';
    }, 50);
  }
  openTaskConfigTemplate(taskList: any, task: any, template: any) {
    const dialogRef = this.dialogService.open(
      template,
      {
        data: { task, schedule: this.formatTaskSchedule(task) },
      },
      this.viewContainerRef,
    );
    dialogRef?.afterClosed().subscribe((res: any) => {
      if (res) {
        const newSchedule = JSON.parse(JSON.stringify(res?.schedule));
        task.schedule = { reminder: newSchedule?.reminder };
        if (newSchedule?.reminder) task.schedule.reminder = true;
        if (this.schedulerForm?.value?.repeat_type === 'once') {
          if (newSchedule?.repeat_details?.length) {
            const possibleDates = this.getAllPossibleDatesForShift(
              newSchedule?.repeat_details,
            );
            const scheduleEndDateTime = new Date(
              this.schedulerForm?.value?.end_day +
                ' ' +
                this.schedulerForm?.value?.end_time,
            );
            const scheduleStartDateTime = new Date(
              this.schedulerForm?.value?.start_day +
                ' ' +
                this.schedulerForm?.value?.start_time,
            );

            possibleDates?.forEach((day: any, index: number) => {
              const endDateTime: any = this.setTime(day, newSchedule?.end_time);
              const startDateTime: any = this.setTime(
                day,
                newSchedule?.start_time,
              );
              if (newSchedule?.start_time > newSchedule?.end_time) {
                endDateTime.setDate(endDateTime.getDate() + 1);
              }
              if (
                endDateTime.getTime() <= scheduleEndDateTime.getTime() &&
                startDateTime.getTime() >= scheduleStartDateTime.getTime()
              ) {
                if (index == 0) {
                  task.schedule.start_datetime = this.setTime(
                    day,
                    newSchedule?.start_time,
                  );
                  task.schedule.end_datetime = endDateTime;
                } else {
                  let duplicateTask = JSON.parse(JSON.stringify(task));
                  duplicateTask.schedule = {};

                  duplicateTask.schedule.start_datetime = this.setTime(
                    day,
                    newSchedule?.start_time,
                  );
                  duplicateTask.schedule.end_datetime = endDateTime;
                  duplicateTask.scheduleAdded = true;
                  taskList.push(duplicateTask);
                }
              } else {
                task.schedule = null;
              }
            });
          } else {
            task.schedule.start_datetime = newSchedule?.start_datetime;
            task.schedule.end_datetime = newSchedule?.end_datetime;
          }
        } else {
          task.schedule.repeat_details = newSchedule?.repeat_details;
          task.schedule.start_time = newSchedule?.start_time;
          task.schedule.end_time = newSchedule?.end_time;
        }
      }
    });
  }
  duplicateTask(taskList: any, subIndex: number) {
    taskList?.splice(subIndex + 1, 0, { ...taskList[subIndex] });
  }
  getAllPossibleDatesForShift(repeat_details: any) {
    const dayNames = [
      'Sunday',
      'Monday',
      'Tuesday',
      'Wednesday',
      'Thursday',
      'Friday',
      'Saturday',
    ];
    return this.scheduleDatesDict?.dates?.filter((date: any) =>
      repeat_details?.includes(dayNames[new Date(date).getDay()]),
    );
  }
  isSameDayCheck = (date: any) => {
    const dateObj = new Date(date);
    dateObj.setHours(0, 0, 0, 0);
    return dateObj.getTime();
  };
  filterOutWeekDays() {
    const availableWeekDays = JSON.parse(
      JSON.stringify(this.scheduleDatesDict?.weekdays || []),
    );
    if (availableWeekDays?.length) {
      if (this.schedulerForm?.value?.repeat_type === 'once') {
        if (
          this.schedulerForm?.value?.start_time >
          this.schedulerForm?.value?.end_time
        ) {
          availableWeekDays?.pop();
        }
      }
      if (availableWeekDays?.length < 2) return [];
    }
    return availableWeekDays;
  }
  changeStartEndDateTime(
    event: any,
    schedule: any,
    field: string,
    invalidField: string,
    overrideOneDayCheck = false,
  ) {
    const isTimeField = ['start_time', 'end_time'].includes(field);
    const isDateTimeField = ['start_datetime', 'end_datetime'].includes(field);

    const formatDate = (date: Date) =>
      isTimeField ? getFormattedTime(date) : getFormattedDateTime(date);

    const validateDate = (
      selectedDate: Date,
      minDateTime: Date,
      maxDateTime: Date,
    ) => {
      const isValid =
        selectedDate.getTime() >= minDateTime.getTime() &&
        selectedDate.getTime() <= maxDateTime.getTime();

      return {
        valid: overrideOneDayCheck || isValid,
        formatted: formatDate(selectedDate),
      };
    };
    const roundDateTimeToQuarterHour = (date: Date): Date => {
      const msPerQuarter = 15 * 60 * 1000;

      const rounded = Math.round(date.getTime() / msPerQuarter) * msPerQuarter;
      return new Date(rounded);
    };

    const getSelectedDate = (minDateTime: Date, maxDateTime: Date) => {
      let selectedDate = new Date();

      if (isDateTimeField) {
        if (event?.target?.value) {
          selectedDate = new Date(event.target.value);
        }
      } else {
        // case where one time shift falls on the same day no need to show them day field just take start_datetime
        selectedDate =
          schedule?.start_datetime &&
          this.schedulerForm?.value?.repeat_type === 'once'
            ? new Date(schedule.start_datetime)
            : field === 'start_time'
              ? new Date(minDateTime)
              : new Date(maxDateTime);

        const [hours, minutes] = event.target.value?.split(':') || ['0', '0'];
        selectedDate.setHours(parseInt(hours), parseInt(minutes), 0, 0);
      }

      return roundDateTimeToQuarterHour(selectedDate);
    };

    const getMinMaxDateTime = () => {
      let minDateTime = new Date(schedule?.minDateTime);
      let maxDateTime = new Date(schedule?.maxDateTime);

      if (this.schedulerForm?.value?.repeat_type !== 'once') {
        // if the shift is a recurring one we can take start and end time from that day no need to take the shift start and end day
        const [startHours, startMinutes] =
          this.schedulerForm?.value?.start_time?.split(':') || ['0', '0'];
        const [endHours, endMinutes] =
          this.schedulerForm?.value?.end_time?.split(':') || ['0', '0'];

        const eventStartTime = new Date();
        eventStartTime.setHours(
          parseInt(startHours),
          parseInt(startMinutes),
          0,
          0,
        );

        const eventEndTime = new Date();
        eventEndTime.setHours(parseInt(endHours), parseInt(endMinutes), 0, 0);

        if (eventEndTime.getTime() < eventStartTime.getTime()) {
          eventEndTime.setDate(eventEndTime.getDate() + 1);
        }

        minDateTime = eventStartTime;
        maxDateTime = eventEndTime;
      }

      return { minDateTime, maxDateTime };
    };

    const { minDateTime, maxDateTime } = getMinMaxDateTime();

    const selectedDate = getSelectedDate(minDateTime, maxDateTime);

    const { valid, formatted } = validateDate(
      selectedDate,
      minDateTime,
      maxDateTime,
    );

    const updateDateTimeField = (
      dateKey: 'start_datetime' | 'end_datetime',
    ) => {
      const baseDate = schedule?.[dateKey]
        ? new Date(schedule[dateKey])
        : new Date();

      const [hours, minutes] = formatted?.split(':') || ['0', '0'];
      baseDate.setHours(parseInt(hours), parseInt(minutes), 0, 0);

      schedule[dateKey] = getFormattedDateTime(baseDate);
    };

    schedule[field] = formatted;
    if (!schedule?.availableDays?.length) {
      // special case to update start_datetime and end_datetime fields in case when there is no day selection
      if (field === 'start_time') {
        updateDateTimeField('start_datetime');
      }

      if (field === 'end_time') {
        updateDateTimeField('end_datetime');
      }
    }
    if (
      new Date(schedule?.start_datetime).getTime() >
      new Date(schedule?.end_datetime).getTime()
    ) {
      // do a check to see if start datetime > end datetime if so make end datetime = start datetime
      schedule.end_datetime = schedule?.start_datetime;
      schedule.end_time = getFormattedTime(new Date(schedule?.end_datetime));
    }

    schedule.invalid[invalidField] = !valid;

    if (isDateTimeField) {
      // Do this only for start_datetime and end_datetime so that it will automatically disable the weekdays selection in case of long one time shifts
      schedule.repeat_details = [];
    }
  }
  selectWeekDays(schedule: any, day: any) {
    schedule.repeat_details = schedule?.repeat_details || [];

    const index = schedule?.repeat_details?.indexOf(day, 0);
    if (index > -1) {
      schedule?.repeat_details.splice(index, 1);
    } else {
      schedule?.repeat_details?.push(day);
    }
  }
  onPositionChange(currentIndex: number, event: any) {
    const input = event.target as HTMLInputElement;
    const newPosition = input.value;
    let newIndex = Number(newPosition) - 1;

    if (isNaN(newIndex) || newIndex < 0) {
      newIndex = 0;
    } else if (newIndex >= this.checkListData?.length) {
      newIndex = this.checkListData?.length - 1;
    }

    const movedItem = this.checkListData?.splice(currentIndex, 1)[0];
    this.checkListData?.splice(newIndex, 0, movedItem);
    setTimeout(() => {
      input.value = (newIndex + 1).toString();
    });
  }

  async onAddCheckpointsToRoute(checkList: any) {
    const dialogRef = this.dialogService.open(AddCheckpointRouteComponent, {
      data: {
        selectedCheckpoints: JSON.parse(
          JSON.stringify(checkList?.selectedCheckpoints || []),
        ),
        cpSiteFilter: checkList?.site || {},
      },
    });

    const res = await firstValueFrom(dialogRef.afterClosed());

    if (res?.selectedCheckpoints)
      checkList.selectedCheckpoints = res?.selectedCheckpoints;
  }
  searchPrompts(event: any) {
    if (event.target.value?.length <= 2) return;
    const params: any = { search_str: event.target.value };
    this.getUserPrompts(params);
  }
  getUserPrompts(params?: any, initialCall = false) {
    this.userPromptService
      .getUserPromptList(params)
      .subscribe((response: any) => {
        const resultData = response?.data || [];

        if (initialCall) {
          this.userPromptTotalCount = response?.total_size;
          this.userPromptsSearchResultsCopy = JSON.parse(
            JSON.stringify(resultData?.splice(0, 3)),
          );
        }
        this.userPromptsSearchResults = resultData?.filter(
          (searchPrompt: any) =>
            !this.userPromptsSearchResultsCopy?.some(
              (prompt: any) => prompt?.id == searchPrompt?.id,
            ),
        );
      });
  }
  openTemplate(
    template: TemplateRef<any>,
    updateItem: string,
    eventData?: any,
  ) {
    let data: any = {};

    this.dialogService.open(
      template,
      {
        data: eventData,
      },
      this.viewContainerRef,
    );
  }
  getPromptsInCheckList(checkList: any) {
    return checkList?.tasks?.filter((task: any) => task?.user_prompt_id)
      ?.length;
  }
}
